export const links = [
    
    {

        "nombre" : "Agenda",
        "link" : "/Agenda",

    },
     {

        "nombre" : "Ligas de Interés",
        "link" : "/Ligas",
        "submenu" : [
            // {
            //     "subMenuNombre" : "Empresas Integras",
            //     "subMenuUrl" : "/Empresas_Integras"
            // },
            {
                "subMenuNombre" : "Ligas de Interés",
                "subMenuUrl" : "/Ligas"
            },

            {
                "subMenuNombre" : "Oficina Virtual de Revisión de Bases",
                "subMenuUrl" : "https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/18"
            },

  {
                "subMenuNombre" : "Oficina Virtual de Empresas Integras",
                "subMenuUrl" : "/OficinaVirtualEmpresasIntegras"
            },

             {
                "subMenuNombre" : "Oficina Virtual de Proveedores y Contratistas",
                "subMenuUrl" : "/OficinaVirtualProveedores"
            },
            {
                "subMenuNombre" : "Proveedores y Contratistas",
                "subMenuUrl" : "/Prov_contra"
            },

            {
                "subMenuNombre" : "Revisión de Bases",
                "subMenuUrl" : "/RevisionBases"
            },
           
            // {
            //     "subMenuNombre" : "Registro en el Padrón de Proveedores y Contratistas del Estado de Hidalgo",
            //      "subMenuUrl" : "https://forms.gle/gnsek9GfiKB6tjCr8"
            // },
            //  {
            //     "subMenuNombre" : "Registro ",
            //      "subMenuUrl" : "/Registro"
            // },
            {
                "subMenuNombre" : "Consulta Padrón",
                 "subMenuUrl" : "https://consultapadroncontraloria.hidalgo.gob.mx/"
            }
            ,

            
          ]
    },

    //   {
    // "nombre" : "Procedimientos de Contratación",
    //     "link" : "/Procedimiento",
    //     // "submenu" : [
    //     //     {
    //     //         "subMenuNombre" : "Procedimientos de Contratación 2025",
    //     //         "subMenuUrl" : "/Licitaciones2025"
    //     //     },    // },

    //     //      {
    //     //         "subMenuNombre" : "Procedimientos de Contratación 2024",
    //     //         "subMenuUrl" : "/Licitaciones2024"
    //     //     },    // },

    //     //      {
    //     //         "subMenuNombre" : "Procedimientos de Contratación 2023",
    //     //         "subMenuUrl" : "/Licitaciones2023"
    //     //     },    // },
    //     // ]
    // },

     {

        //  "nombre" : "Sistema de Georreferenciación de Obra Pública",
           "nombre" : "Sistema de Georreferenciación",
         "link" : "https://sigopcontraloria.hidalgo.gob.mx/",
       
     },


       {

         "nombre" : "SÚPER AGENTES",
         "link" : "/SuperAgentes",
       
     },
    

    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "Recurso Federal 1 y 5 al Millar",
                "subMenuUrl" : "/Armonizacion"
            },
            {
                "subMenuNombre" : "Recurso Estatal 5 al Millar",
                "subMenuUrl" : "/Recursos"
            }
            // ,
            // {
            //     "subMenuNombre" : "Licitaciones",
            //     "subMenuUrl" : "/Licitaciones"
            // },
            // {
            //     "subMenuNombre" : "Disciplina Financiera",
            //     "subMenuUrl" : "/Disciplina"
            // }
        ]
    },
    {

        "nombre" : "Trámites y Servicios",
        "link" : "/Tramite",
        "submenu" : [
            {
                "subMenuNombre" : "Padrón de Proveedores",
                 "subMenuUrl" : "/Tramite/Proveedores"
            },
            {
                "subMenuNombre" : "Padrón de Contratistas",
                 "subMenuUrl" : "/Tramite/Contratistas"
            },
            {
                "subMenuNombre" : "Constancias de No Inhabilitación",
                "subMenuUrl" : "https://contraloriahidalgo.gob.mx/inhabilitacion/constancias/"
            },
            {
                "subMenuNombre" : "Sistema de Declaración Patrimonial",
                "subMenuUrl" : "http://declaranet.hidalgo.gob.mx:5000/"
            },
            {
                "subMenuNombre" : "Atención de Quejas y Denuncias",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/443/"
            },
            {
                "subMenuNombre" : "Quejas de Obra Pública",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/6582"
            }
        ]

    },
   
    {
    "nombre" : "UEEPCI",
        "link" : "/UEEPCI",
        "submenu" : [
            {
                "subMenuNombre" : "UEEPCI",
                "subMenuUrl" : "/UEEPCI"
            },    // },
        ]
    },

    //    {
    // "nombre" : "Control Interno",
    //     "link" : "/ControlInterno",
    // },
    // {
    // "nombre" : "Empresas Íntegras",
    //     "link" : "/Empresas_Integras",
    //     "submenu" : [
    //         {
    //             "subMenuNombre" : "Empresas Integras",
    //             "subMenuUrl" : "/Empresas_Integras"
    //         },    // },
    //     ]
    // },

    // {
    //     "nombre" : "Contralores",
    //         "link" : "/Contralores",
            
    //     }

    //     "nombre" : "Comisión Permanente",
    //     "link" : "/Comisión Permanente",

    // },

    // {

    //     "nombre" : "Súper Agentes",
    //     "link" : "/Programa",

    // }

]